export enum ServerManagerType {
  Mock = 'mock',
  TxKeys = 'tx-keys',
  Csas = 'csas',
}
